
















































































































import {
  defineComponent,
  Ref,
  ref,
  set,
  PropType,
  watch,
  useFetch,
} from "@nuxtjs/composition-api";

import { useSearchProducts, useUiHelpers } from "~/composables";
import { getFilterConfig } from "~/modules/catalog/category/config/FiltersConfig";
import PriceRangeSlider from "~/modules/catalog/category/components/filters/filterPrice/PriceRangeSlider.vue";

import type { Aggregation, AggregationOption } from "~/modules/GraphQL/types";
import {
  SelectedFiltersInterface,
  useFilters,
} from "~/modules/catalog/category/components/filters/useFilters";
import { decodeUid, getBgColorValue } from "~/helpers";
import { mapAgg } from "~/modules/catalog/category/helpers/mapAgg";
import { isFilterEnabled } from "~/modules/catalog/category/config/FiltersConfig";

export interface UseFiltersProviderInterface {
  selectedFilters: Ref<SelectedFiltersInterface>;
  filters: Ref<Aggregation[]>;
}

export default defineComponent({
  name: "CategoryFiltersMobile",
  components: {
    PriceRangeSlider,
  },
  props: {
    categoryUid: {
      type: String,
      default: () => "",
    },
  },

  setup(props, { emit }) {
    const { changeFilters } = useUiHelpers();
    const { fetchProducts, loading: loadingProduct } = useSearchProducts();
    const filters = ref<Aggregation[]>([]);
    const isLoading = ref(true);

    const {
      selectedFilters,
      selectFilter,
      getRemovableFilters,
      getSelectedFiltersFromUrl,
    } = useFilters();

    const isOpenSize = ref(false);
    const isOpenColor = ref(false);
    const isOpenPrice = ref(false);
    const priceFilterMin = ref<number | null>(null);
    const priceFilterMax = ref<number | null>(null);
    const selected = ref<SelectedFiltersInterface>(getSelectedFiltersFromUrl());

    useFetch(async () => {
      if (!props.categoryUid) {
        filters.value = [];
        return;
      }
      const categoryId = decodeUid(props.categoryUid);
      const params = {
        ids: [String(categoryId)],
        aggs: true,
      };

      const { aggregations } = await fetchProducts(params);
      filters.value = mapAgg(aggregations)
        .filter((filter) => isFilterEnabled(filter.attribute_code))
        .sort((a, b) => {
          const order = ["size", "mastercolor", "price"];
          return (
            order.indexOf(a.attribute_code) - order.indexOf(b.attribute_code)
          );
        });
    });

    const chooseFilterMobile = (
      filter: Aggregation,
      option: AggregationOption
    ) => {
      if (isFilterActiveMobile(filter.attribute_code, option)) {
        removeFilterMobile(filter.attribute_code, option.value);
      } else {
        selectFilterMobile(filter, option);
      }
    };

    const changeFilterPriceMobile = (option: AggregationOption) => {
      const filter = filters.value?.find(
        (filter) => filter.attribute_code === "price"
      );
      selectFilterMobile(filter, option);
    };

    const selectFilterMobile = (
      filter: Aggregation,
      option: AggregationOption
    ) => {
      if (!selected.value[filter.attribute_code]) {
        set(selected.value, filter.attribute_code, []);
      }

      if (
        selected.value[filter.attribute_code].find((f) => f === option.value)
      ) {
        selected.value[filter.attribute_code] = selected.value[
          filter.attribute_code
        ]?.filter((f) => f !== option.value);
        return;
      }
      if (filter.attribute_code !== "price") {
        selected.value[filter.attribute_code].push(String(option.value));
      } else {
        selected.value["price"] = [String(option.value)];
      }
    };

    const removeFilterMobile = (attrCode: string, valToRemove: string) => {
      if (!selected.value[attrCode]) return;
      selected.value[attrCode] = selected.value[attrCode].filter(
        (value) => value !== valToRemove
      );
    };

    const isFilterActiveMobile = (
      attrCode: string,
      option: AggregationOption
    ) => {
      return selected.value[attrCode]?.includes(option.value) || false;
    };

    const doApplyFiltersMobile = () => {
      selected.value.sort = [];

      changeFilters(selected.value, false);
      const removableFilters = getRemovableFilters(
        filters.value,
        selected.value
      );
      emit("reloadProducts");
      emit("removableFiltersMobile", removableFilters);
      CloseFilterMobile();
    };

    const CloseFilterMobile = () => {
      emit("closeFilterMobile");
    };

    const doClearFiltersMobile = async () => {
      selected.value = {
        size: [],
        mastercolor: [],
        price: [],
        sort: [],
      };
    };

    watch(
      () => filters.value,
      (newVal) => {
        const priceFilter = newVal.find(
          (filter) => filter.attribute_code === "price"
        );

        if (
          priceFilter &&
          priceFilter.options &&
          priceFilter.options.length > 0
        ) {
          const priceValues = priceFilter.options
            .map((option) => {
              return Number(option.value);
            })
            .filter((value) => !isNaN(value));

          if (priceValues.length > 0) {
            priceFilterMin.value = Math.min(...priceValues);
            priceFilterMax.value = Math.max(...priceValues);
          } else {
            priceFilterMin.value = -Infinity;
            priceFilterMax.value = Infinity;
          }
        } else {
          priceFilterMin.value = -Infinity;
          priceFilterMax.value = Infinity;
        }
        // updateRemovableFilters();
      },
      { immediate: true }
    );

    return {
      selectFilter,
      getFilterConfig,
      selectedFilters,
      isLoading,
      isOpenSize,
      isOpenColor,
      isOpenPrice,
      CloseFilterMobile,
      chooseFilterMobile,
      changeFilterPriceMobile,
      doApplyFiltersMobile,
      doClearFiltersMobile,
      getBgColorValue,
      isFilterActiveMobile,
      selected,
      priceFilterMin,
      priceFilterMax,
      filters,
    };
  },
});
